import Ban1 from '../images/1.jpg';
import Ban2 from '../images/2.jpg';
import Ban3 from '../images/3.jpg';


export const Sliderdata = [
    {
        id:"0",
        imgurl: Ban1,
        text: "Summers SALE up to 50% OFF what are you wating for"
    },
    {
        id: "1",
        imgurl: Ban2,
        text: "AUTUMN is coming, choose what suits you THE BEST",
      },
      {
        id: "2",
        imgurl: Ban3,
        text: "Make your feet as comfortable as walking on the beach",
      },
]
